<template>
  <li class="m-secItem">
    <slot>メニューがありません</slot>
  </li>
</template>

<script>
export default {
  computed: {
  },
  mounted () {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getFamilies()
    })
  }
}
</script>

<style lang="scss">
.m-secItem{
  position: relative;
  display: inline-block;
  a {
    display: block;
    padding: 1em 2em;
    position: relative;
    text-decoration:none;
    &.router-link-active {
      &:before {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 2px;
        bottom:0;
        left: 0;
        background-color: var(--color-point)
      }
    }
  }
  &:after {
    content: "";
    display: block;
    position: absolute;
    height: 60%;
    width: 1px;
    right: 0;
    top: 20%;
    background-color: var(--color-border)
  }
}
</style>



// WEBPACK FOOTER //
// SecItem.vue?317822b7